import React from 'react';
import { TextLink } from '@dsg-tech/homefield-react';
import { CTA } from '../../../types';
import { setDataEmTag } from '../../../utility/utility';
import FundSiteFooterSocialLinks from './FundSiteFooterSocialLinks/FundSiteFooterSocialLinks';
import { useAppSelector } from '../../../store/store';
import { footerTaxoSelector } from '../../../store/selectors/taxonomySelector';
import { storeIdentifierNameSelector } from '../../../store/selectors/commonSelector';
import './FundSiteFooter.scss';

declare global {
  interface Document {
    footerTheme: Theme;
  }
}

interface Theme {
  env: string;
  apiKey: string;
  signupUrl: string;
}

export interface FooterLink {
  title: string;
  href: string;
  id: string;
}

export interface CommunicationSection {
  emailHeadline: string;
  smsHeadline: string;
  storeIdentifierName?: string;
}

export default function FundSiteFooter() {
  const taxoContent = useAppSelector(footerTaxoSelector);
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);

  const mapFooterLinks = (data: CTA[]): FooterLink[] => {
    if (data) {
      const links: FooterLink[] = data.map((link: CTA) => {
        return { title: link.linkTitle, href: link.link, id: '' };
      });
      return links;
    }
    return [];
  };

  const footerLinks = mapFooterLinks(taxoContent['Footer Links'][0].cta);

  const isSM = storeIdentifierName === 'sm';

  return (
    <div
      className={`${isSM ? 'sm-footer' : 'plf-footer'} hmf-px-xl hmf-py-l`}
      id="sm-footer"
      data-testid="footer-links">
      <div className="footer-container hmf-display-flex hmf-flex-column hmf-mx-auto">
        <div className="footer-site-link-container hmf-display-flex hmf-flex-column hmf-flex-wrap hmf-align-items-center hmf-justify-content-center">
          {footerLinks.map(({ title, id, href }) => {
            return (
              <li
                id={id}
                key={title}
                className="footer-site-link hmf-legal-xs hmf-display-flex hmf-justify-content-center hmf-mb-l ">
                {title && (
                  <TextLink
                    variant="group-inverse"
                    size="small"
                    href={href}
                    tabIndex={0}
                    data-em={setDataEmTag('Footer', title)}>
                    {title}
                  </TextLink>
                )}
              </li>
            );
          })}
        </div>
        <div className="footer-container-middle hmf-display-flex hmf-justify-content-center hmf-mb-l">
          <FundSiteFooterSocialLinks />
        </div>
        <div className="footer-container-bottom hmf-display-flex hmf-justify-content-center">
          <p className="footer-copyright hmf-m-0 hmf-legal-s">
            © {new Date().getFullYear()} {isSM ? 'DICK’S Sporting Goods' : 'Public Lands'}
          </p>
        </div>
      </div>
    </div>
  );
}
